// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalFooter-modalFooter-1N5Ku"};